<template>
  <div class="header">
    <div class="flex gap-2 items-start mb-5">
      <div class="heading">
        <sc-text tag="h3" :field="fields.header" />
      </div>
    </div>
    <div class="flex mb-1 intro items-center ml-2 mr-2">
      <sc-text tag="p" :field="fields.introduction" />
    </div>
  </div>
</template>

<script>
import { Text } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'PageIntroduction',
  components: {
    ScText: Text,
  },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    //imageUrl() {
    //  const img = this.fields?.image || {};
    //  // try common shapes used by disconnected/layout service
    //  return img.src || (img.value && img.value.src) || (img.fields && img.fields.src) || '';
    //},
  },
};
</script>
